<template>
    <cadastro-simples-form
        endpoint="tipo-renda-familiar"
        rota-base="/admin/tipo-renda-familiar"
        titulo-singular="Tipo de Renda Familiar"
        :campos-extras='[{"campo":"valor_minimo","label":"Valor mínimo (R$)","tipo":"string"},{"campo":"valor_maximo","label":"Valor máximo (R$)","tipo":"string"},{"campo":"ordem","label":"Ordem","tipo":"int"}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
